export default __webpack_public_path__ + "images/f705cdeed19855eb73cf77a40ff7a8ce.png";